"use strict";
var TypeEnum;
(function (TypeEnum) {
    TypeEnum[TypeEnum["String"] = 0] = "String";
    TypeEnum[TypeEnum["Number"] = 1] = "Number";
    TypeEnum[TypeEnum["Date"] = 2] = "Date";
    TypeEnum[TypeEnum["Boolean"] = 3] = "Boolean";
})(TypeEnum = exports.TypeEnum || (exports.TypeEnum = {}));



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/models/type-enum.js
// module id = 37
// module chunks = 0